import ng from 'angular';
import { IGerenciamentoDocumento } from '../models/gerenciamentodocumento.model';

export class CancelarAssinaturaDocumentoModalController implements ng.IController {

    static $inject = [
        '$uibModalInstance',
        'documento',
    ];

    public comentario: string = '';

    constructor(
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public documento: IGerenciamentoDocumento,
    ) {}

    public confirmar(): void {
        if (!this.comentarioValido()) {
            return;
        }

        this.$uibModalInstance.close(this.comentario.trim());
    }

    public cancelar(): void {
        this.$uibModalInstance.dismiss('cancelar');
    }

    public comentarioValido(): boolean {
        return !!this.comentario && !!this.comentario.trim();
    }
}
